<template>
  <ModalUserAlreadyRegistered
    v-if="UserAlreadyRegisteredEmail"
    :email="UserAlreadyRegisteredEmail"
    @close="onModalCloseUserAlreadyRegistered"
  />
  <ModalInvitesIncomplete
    v-if="showIncomplete"
    @stop="ModalInvitesIncompleteStop"
    @proceed="ModalInvitesIncompleteProceed"
  />
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <img class="mx-auto h-[100px] w-auto" src="/img/spike-logo.svg" alt="Spike" />
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">Invite team members</h2>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div
        class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10"
        :class="
          result === 'TeamInviteResult.Fail' ||
          result === 'TeamInviteResult.AlreadyRegistered' ||
          result === 'TeamRemoveResult.Fail'
            ? 'shakeX'
            : ''
        "
      >
        <div class="space-y-6 text-gray-700 text-sm">
          <p>
            Add members to your team. We will send an invite by email to each user. This step is optional, you can add
            members later in the settings. Click Next to continue.
          </p>

          <div v-for="t in team" :key="t.id" class="mt-1 flex rounded-md shadow-sm">
            <input
              v-model="t.email"
              name="email"
              type="email"
              autocomplete="off"
              required
              :disabled="t.state !== 'input'"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              :maxlength="maxLength"
              :minlength="minLength"
              placeholder="example@email.com"
              @keyup="validateEmail(t)"
              :class="t.state !== 'input' ? 'bg-gray-200' : ''"
              class="appearance-none block w-full px-3 py-2 rounded-l-md border border-gray-300 placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary"
            />
            <button
              type="button"
              class="relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 font-medium rounded-r-md bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-primary focus:border-primary"
              :disabled="result === 'loading'"
              @click="
                if (t.state === 'inviting' || t.state === 'removing') {
                  /* ... */
                } else if (t.state === 'invited') {
                  /* X icon */
                  // removeTest(t);
                  remove(t);
                } else {
                  /* Mail icon */
                  // t.valid && inviteTest(t);
                  t.valid && invite(t);
                }
              "
            >
              <span v-if="t.state === 'inviting' || t.state === 'removing'">...</span>
              <XIcon v-else-if="t.state === 'invited'" class="w-5 h-5 text-red-600" />
              <MailIcon v-else class="w-5 h-5" :class="t.valid ? 'text-primary' : 'text-gray-400'" />
            </button>
          </div>
          <p class="text-sm text-primary">
            <a
              href="#"
              @click.prevent="addEnabled && add()"
              :class="
                addEnabled ? 'text-primary hover:text-primary-600 hover:underline' : 'text-gray-400 cursor-default'
              "
              >+ Add another</a
            >
          </p>
          <div class="flex w-full justify-center text-sm">
            <template v-if="result === 'loading'">
              <ScalingDots />
            </template>
            <template v-else-if="result === 'exception'">
              <XCircleIcon class="w-5 h-5 text-red-600" aria-hidden="true" />
              <span class="ml-2 text-red-600">failed to contact the server, please retry</span>
            </template>
            <template v-else-if="result === 'TeamInviteResult.Fail'">
              <XCircleIcon class="w-5 h-5 text-red-600" aria-hidden="true" />
              <span class="ml-2 text-red-600">error, please check the email address</span>
            </template>
            <template v-else-if="result === 'TeamInviteResult.AlreadyRegistered'">
              <XCircleIcon class="w-5 h-5 text-red-600" aria-hidden="true" />
              <span class="ml-2 text-red-600">User already exists</span>
            </template>
            <template v-else-if="result === 'TeamInviteResult.Success'">
              <CheckCircleIcon class="w-5 h-5 text-green-600" aria-hidden="true" />
              <span class="ml-2 text-green-600">success</span>
            </template>

            <template v-else-if="result === 'TeamRemoveResult.Fail'">
              <XCircleIcon class="w-5 h-5 text-red-600" aria-hidden="true" />
              <span class="ml-2 text-red-600">error, please complete sign-up and check settings</span>
            </template>
            <template v-else-if="result === 'TeamRemoveResult.NotOnTheTeam'">
              <!-- ignore this -->
              <CheckCircleIcon class="w-5 h-5 text-green-600" aria-hidden="true" />
              <span class="ml-2 text-green-600">removed</span>
            </template>
            <template v-else-if="result === 'TeamRemoveResult.Success'">
              <CheckCircleIcon class="w-5 h-5 text-green-600" aria-hidden="true" />
              <span class="ml-2 text-green-600">removed</span>
            </template>
            <template v-else>
              <!-- dummy - keep height -->
              <span>&nbsp;</span>
            </template>
          </div>
          <div class="w-full sm:flex sm:space-x-4">
            <button
              type="submit"
              class="w-24 inline-flex justify-center rounded-md border border-primary hover:border-primary-600 shadow-sm px-4 py-2 bg-white text-base font-medium text-primary hover:text-primary-600 focus:outline-none focus:ring-2"
              :disabled="result === 'loading'"
              @click="onNext()"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  Url,
  TeamInviteRes,
  TeamInviteResult,
  TeamInviteReq,
  TeamRemoveRes,
  TeamRemoveResult,
  TeamRemoveReq,
  ScreenName,
} from "@spike/app2-sitemap/src/auth.js";
import * as defaults from "@spike/app2-sitemap/src/defaults.js";
import axios from "axios";
import { CheckCircleIcon, MailIcon, XCircleIcon } from "@heroicons/vue/solid";
import { XIcon } from "@heroicons/vue/outline";
import sleep from "@util/sleep";
import { onMounted, reactive, ref } from "vue";
import ModalInvitesIncomplete from "../components/TeamInvite/ModalInvitesIncomplete.vue";
import ModalUserAlreadyRegistered from "../components/TeamInvite/ModalUserAlreadyRegistered.vue";
import ScalingDots from "../components/spinners/ScalingDots.vue";
import * as Nav from "../navigation";

enum TeamMemberState {
  input = "input",
  inviting = "inviting",
  invited = "invited",
  removing = "removing",
  removed = "removed",
}

let i = 0;
interface TeamMember {
  id: number;
  email: string;
  valid: boolean;
  state: TeamMemberState;
}

let team = reactive([] as TeamMember[]);
const UserAlreadyRegisteredEmail = ref("");
const minLength = ref<number>(6);
const maxLength = ref<number>(100);
const addEnabled = ref<boolean>(false); // TODO: on response received - all team.state === invited
const result = ref<string | null>(null);
const showIncomplete = ref(false);

onMounted(() => {
  Nav.prevScreensComplete(ScreenName.TeamInvite);
  add();

  // testing:
  // result.value = "loading";
  // result.value = "exception";
  // result.value = "TeamInviteResult.Success";
  // result.value = "TeamInviteResult.Fail";
});

//#region ux

// https://codepen.io/CSWApps/pen/MmpBjV
const reg =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

function validateEmail(t: TeamMember) {
  const e = t.email;
  t.valid = !e ? false : reg.test(e);
  result.value = null;
}

function add(keepResult: boolean = false) {
  team.push({
    id: ++i,
    email: "",
    valid: false,
    state: TeamMemberState.input,
  });
  addEnabled.value = false;
  if (!keepResult) {
    result.value = null;
  }
}

function isIncomplete() {
  let t = team[team.length - 1];
  return t.state === TeamMemberState.input && t.email;
}

//#endregion

//#region invite

async function invite(t: TeamMember) {
  try {
    t.state = TeamMemberState.inviting;
    const requestBody: TeamInviteReq = {
      email: t.email,
    };
    result.value = "loading";
    const response = await axios.post(Url.server.shared.teamInvite, requestBody);
    // console.log("invite-team response:", response);
    const res: TeamInviteRes = response.data;

    switch (res.result) {
      case TeamInviteResult.Success:
        inviteSuccess(t);
        break;
      case TeamInviteResult.Fail:
        inviteFail(t);
        break;
      case TeamInviteResult.AlreadyRegistered:
        inviteAlreadyRegistered(t);
        break;
      default:
        inviteException(t);
        break;
    }
  } catch (e) {
    // console.error("invite-team failed:", e);
    inviteException(t);
  }
}

async function inviteTest(t: TeamMember) {
  t.state = TeamMemberState.inviting;
  result.value = "loading";
  await sleep(500);

  // testing
  inviteSuccess(t);
  // inviteFail(t);
  // inviteAlreadyRegistered(t);
  // inviteException(t);
}

async function inviteSuccess(t: TeamMember) {
  result.value = "TeamInviteResult.Success";
  t.state = TeamMemberState.invited;
  addEnabled.value = true;
  document?.activeElement?.blur(); // remove focus from invite button
}

async function inviteFail(t: TeamMember) {
  result.value = "TeamInviteResult.Fail";
  t.state = TeamMemberState.input;
}

async function inviteAlreadyRegistered(t: TeamMember) {
  result.value = "TeamInviteResult.AlreadyRegistered";
  UserAlreadyRegisteredEmail.value = t.email;
  t.state = TeamMemberState.input;
}

async function inviteException(t: TeamMember) {
  result.value = "exception";
  t.state = TeamMemberState.input;
}

function onModalCloseUserAlreadyRegistered() {
  UserAlreadyRegisteredEmail.value = "";
}

//#endregion

//#region remove

async function remove(t: TeamMember) {
  try {
    t.state = TeamMemberState.removing;
    const requestBody: TeamRemoveReq = {
      email: t.email,
    };

    result.value = "loading";
    const response = await axios.post(Url.server.shared.teamRemove, requestBody);
    // console.log("remove-team response:", response);
    const res: TeamRemoveRes = response.data;

    switch (res.result) {
      case TeamRemoveResult.Success:
        removeSuccess(t);
        removeUx(t);
        break;
      case TeamRemoveResult.Fail:
        removeFail(t);
        break;
      case TeamRemoveResult.NotOnTheTeam:
        removeNotOnTheTeam(t);
        removeUx(t);
        break;
      default:
        removeException(t);
        break;
    }
  } catch (e) {
    // console.error("remove-team failed:", e);
    removeException(t);
  }
}

async function removeTest(t: TeamMember) {
  t.state = TeamMemberState.removing;
  result.value = "loading";
  await sleep(500);
  // testing
  removeSuccess(t);
  removeUx(t);

  // removeFail(t);

  // removeNotOnTheTeam(t);
  // removeUx(t);

  // removeException(t);
}

function removeUx(t: TeamMember) {
  const i = team.indexOf(t);
  team.splice(i, 1);
  if (team.length === 0) {
    add(true);
  }
}

async function removeSuccess(t: TeamMember) {
  // show message
  result.value = "TeamRemoveResult.Success";
  t.state = TeamMemberState.removed;
  document?.activeElement?.blur(); // remove focus from remove button
}

async function removeFail(t: TeamMember) {
  result.value = "TeamRemoveResult.Fail";
  t.state = TeamMemberState.invited;
}

async function removeNotOnTheTeam(t: TeamMember) {
  result.value = "TeamRemoveResult.NotOnTheTeam";
  t.state = TeamMemberState.removed;
  document?.activeElement?.blur(); // remove focus from remove button
}

async function removeException(t: TeamMember) {
  result.value = "exception";
  t.state = TeamMemberState.invited;
}

//#endregion

function ModalInvitesIncompleteStop() {
  showIncomplete.value = false;
}

function ModalInvitesIncompleteProceed() {
  Nav.complete(ScreenName.TeamInvite);
  location.href = defaults.Url.welcome;
}

function onNext() {
  const incomplete = isIncomplete();
  if (incomplete) {
    showIncomplete.value = true;
  } else {
    // proceed
    Nav.complete(ScreenName.TeamInvite);
    location.href = defaults.Url.welcome;
  }
}
</script>
